(function () {
    'use strict';

    angular.module("imApp").factory("stockCorrectionService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 440,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 441,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
